import './themeDefaults';

/* eslint-disable sort-keys-fix/sort-keys-fix */
export default ({ datepickerReact }) => ({
  dark: {},
  inputIcon: {
    '& svg': {
      fill: datepickerReact.inputIconButtonColor
    },
    '&$dark': {
      '& svg': {
        fill: datepickerReact.dark.inputIconButtonColor
      }
    },
    position: 'absolute',
    right: 9,
    top: 10
  },
  inputWrapper: {
    ...datepickerReact.inputWrapper,
    '& input': {
      background: datepickerReact.input.backgroundColor,
      boxSizing: 'border-box',
      color: datepickerReact.input.color,
      ...datepickerReact.textInput
    },
    '&$dark': {
      '& input': {
        background: datepickerReact.input.dark.backgroundColor,
        color: datepickerReact.input.dark.color
      }
    }
  },
  toggle: {
    '&:focus': {
      outlineColor: datepickerReact.focusColor
    },
    background: 'transparent',
    border: '0',
    height: 34,
    position: 'absolute',
    width: 34,
    ...datepickerReact.textInputToggle
  },
  screenReaderLabel: {
    top: -1
  }
});
